import { Component, Input } from '@angular/core';
import type { FullCalculateFormValues } from '@innogy/become-a-customer/shared';
import type {
  CalculateComponentContent,
  CalculateComponentRendering,
} from '@innogy/become-a-customer/shared/interfaces';
import type { TypedComponentRendering } from '@core/jss-models';
import type { FormGroupControls, FormGroupState } from 'ngrx-forms';
import { CommonModule } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';

@Component({
  selector: 'wl-calculate-form-existing-customer',
  templateUrl: './calculate-form-existing-customer.component.html',
  standalone: true,
  imports: [
    CommonModule,
    AutomationIdDirective,
    CommonUiUtilityComponentsModule,
    CommonUiFormsModule,
  ],
})
export class CalculateFormExistingCustomerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: TypedComponentRendering<CalculateComponentRendering>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) content!: CalculateComponentContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() controls?: FormGroupControls<FullCalculateFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState?: FormGroupState<FullCalculateFormValues>;

  get showExistingCustomerMessage() {
    return this.controls?.existingCustomer.value;
  }
}
